import Vue from 'vue';
import Router from 'vue-router';
// import iView from 'iview';
import store from '../store';

// 首页路由
import home from './routers/home';
/** 系统管理 */
import system from './routers/system';

/** 智慧服务 */
import smartservice from './routers/smartservice';
import thirdorg from './routers/thirdorg';
Vue.use(Router);

// 解决menuItem——在当前路由跳转到相同路由时报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 1、组件缓存机制：对路由的mate对象属性定义keep-alive: true能缓存当前组件页面，第二次进来不进行重新渲染。
// 2、路由权限：对路由的meta对象属性定义login: true能

const router = new Router({
    mode : 'history',
    base:"/front/",
    routes : [{ // layout
        path : '/',
        name : 'Layout',
        redirect : '/home',
        component : resolve => {
            require(['components/Layout/index.vue'], resolve);
        },
        meta : {
            // login : true,
            title : '首页'
        },
        // 路由组件列表
        children : [
            ...home, // 首页路由
            ...system, // 系统管理
            ...smartservice, //智慧服务
            ...thirdorg,
        ]
    },
    { // 登录
        path : '/login',
        name : 'Login',
        component : resolve => {
            require(['components/Login/index.vue'], resolve);
        },
        meta : {
            login : false,
            title : '登录'
        }
    },
    // , { // 注册
    //     path : '/login',
    //     name : 'Login',
    //     component : resolve => {
    //         require(['components/LogRes/login.vue'], resolve);
    //     },
    //     meta : {
    //         login : false,
    //         title : '登录'
    //     }
    // }
    { // 始终放在最后
        path : '*',
        name : '404',
        component : resolve => {
            require(['components/Error/index.vue'], resolve);
        },
        meta : {
            login : false,
            title : 404
        }
    }
    ]
});

// 路由加载前
router.beforeEach((to, from, next) => {
    const {state : {isLogin}} = store;
    if (to.meta.login && !isLogin) {
        router.push({
            path : '/login'
        })
    } else {
      console.log(to.path.indexOf('http'), typeof(to.path.indexOf('http')))
      if (to.path.indexOf('http') != -1) {
        console.log(to.path.substr(1))
        next(false)
        window.open(to.path.substr(1))
      } else {
        next()
      }
    }
});

// 路由加载完成后
router.afterEach((to) => {
    // 路径匹配面包屑导航名
    let bread = getBreadName(to)
    store.commit('updatedBreadName', bread)
    store.commit('updatedActiveMenu', to.path)
    // 页面title
    document.title = to.meta.title;
    // 滚回顶部
    window.scrollTo(0, 0);
});

// 根据路径匹配面包屑导航名
function getBreadName(route) {
    const title = {
        system: '系统管理',
    }
    var titleList = []
    let pathArr = route.path.split('/')
    pathArr.forEach(e => {
      var name = title[e]
      if (name) {
        titleList.push(name)
        titleList.push(route.meta.title)
      }
    })
    return titleList
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js